export const trackingDurationList = ['6hrs', '12hrs', '1d', '2d', '5d', '1w', '2w', '1m'];
